<template>
  <template v-if="question?.status !== 'READ_ONLY'">
    <div :id="`waffle-radio-container_${question.name}`" class="d-flex flex-wrap waffle-radio-container" :class="{'flex-column' : question.options.length > 2, }">
      <div
          :id="`waffle-radio-input_${question.name}`"
          class="waffle-radio-input radio input-border position-relative"
          :class="{
        'me-4': question.options.length === 2 && index === 0,
        'mb-2': question.options.length > 2 && index + 1 !== question.options.length,
        'waffle-invalid-border': error && hasBeenInteractedWith,
      }"
          v-for="(option, index) in question.options"
          :key="index"
      >

        <label  class="waffle-radio-label" :for="`${question.name}-radio-${option.value}`" :class="{selected: currentValue === option.value && !this.error} ">
          <input
              v-bind="$attrs"
              type="radio"
              :disabled="disabled"
              :name="question.name"
              :id="`${question.name}-radio-${option.value}`"
              :value="option.value"
              :checked="currentValue === option.value"
              @click.stop="$emit('user-interaction')"
              @change="validate(option)"
          />
          <span :id="`waffle-radio-label-text_${question.name}`" class="waffle-radio-label-text mb-1">{{ option.text }}</span>
        </label>
      </div>
    </div>
    <slot name="helptext" :isConfirm="!disableConfirm && (question.value && question?.prefilled) && !error" :isError="error"
          :confirmCb="() =>{$emit('user-interaction') ;$emit('confirm'); }"></slot>
  </template>
  <ReadOnly
      v-else
      :question="question"
      :value="currentValue ? currentValue:'-'"
      :forcePromptPlaceholder="forcePromptPlaceholder"
  />
</template>

<script>
import ReadOnly from "@/components/themeable-components/ReadOnly.vue";

export default {
  name: "RadioChoice",
  components: {ReadOnly},
  props: ["question", "modelValue",'hideSubText','skipEagerValidation','disableConfirm','forcePromptPlaceholder','hasBeenInteractedWith','disabled'],
  emits: ["update:modelValue", "field-error",'confirm','user-interaction'],
  data() {
    return {
      currentValue: null,
      error:this.question.error || '',
    };
  },
  mounted() {
    this.currentValue = this.question.value;

    if(!this.skipEagerValidation){
      this.error = this.question.error
      if(this.error ){
        return this.$emit('field-error', true)
      }
      this.validate()
    }
  },
  methods:{
    validate(option){
      this.currentValue = option ? option.value: this.currentValue;
      if(!this.currentValue && this.question.required){
        this.error='Required'
        return this.$emit('field-error', true)
      }else{
        this.error=''
        this.$emit('update:modelValue',  this.currentValue);
        this.$emit('field-error', false)
      }
    }
  },
  watch: {
    question: {
      handler(newQuestion) {
        if(newQuestion.value !== undefined && newQuestion.value  !== this.currentValue){
          this.currentValue = newQuestion.value
          this.validate();
          return
        }
        if (newQuestion.error) {
          this.error = newQuestion.error
          return this.$emit('field-error', true)
        }
        this.error = ''
        return this.$emit('field-error', false)
      },
      deep: true,
    }
  },
};
</script>